export const generateFilter = (type: string, value: string, _order: number) => {
  return {
    field: type,
    key: type,
    op: 'eq',
    value: value,
    display: value,
    originalField: type,
    _order: _order,
  };
};
